import Auth from '@/pages/Auth';
import UpdatePassword from '@/pages/UpdatePassword';
import CompanyOnboarding from '@/pages/CompanyOnboarding';
import { StaticRouteConfig } from './types';

export const authRoutes: StaticRouteConfig[] = [
  { path: '/login', component: Auth },
  { path: '/auth', component: Auth },
  { path: '/auth/callback', component: Auth },
  { path: '/reset-password', component: UpdatePassword },
  { path: '/update-password', component: UpdatePassword },
  { path: '/onboarding/company', component: CompanyOnboarding },
];
